import axios from 'axios'

import { getRequestConfig } from 'legacy/services/auth'
import getLoadboardFwdQueryParams from 'legacy/utils/getLoadboardFwdQueryParams'

export async function createAccountCarrier(data) {
  const requestConfig = await getRequestConfig()
  const queryParams = getLoadboardFwdQueryParams()

  return axios.post('/api/v2/carriers', JSON.stringify(data), {
    ...requestConfig,
    params: {
      ...(requestConfig.params || {}),
      ...queryParams,
    },
  })
}

export async function createAccountCarrierIntermodal(data) {
  const requestConfig = await getRequestConfig()
  const queryParams = getLoadboardFwdQueryParams()

  return axios.post('/api/v2/intermodal/carrier', JSON.stringify(data), {
    ...requestConfig,
    params: {
      ...(requestConfig.params || {}),
      ...queryParams,
    },
  })
}
